<template>
  <!-- import styles if needed -->
  <PageLoader class="mb-5 mt-5" v-if="isLoading"></PageLoader>
  <div v-if="is_loaded" v-show="!isLoading">
    <!-- import styles if needed -->

    <div v-if="is_loaded">
      <div id="current-user-wrapper">
        <snipp-current-user :campaign-id="campaignId" :user-status="user_status" @show-registration="showRegistration"
          @snipp-logout="handleSnippLogout" @show-confirmation="showConfirmation" @current-user="handleCurrentUser"
          :custom-css="customCssUrl" :language="$t('Language')"></snipp-current-user>
      </div>
      <div id="registration-wrapper" v-if="registration_enabled">
        <snipp-registration app-source="CampaignWidget" refresh-reload="true" :campaign-id="campaignId"
          :show-confirmation="show_confirmation" :custom-css="customCssUrl" :is-logged-out="is_logged_out"
          @is-registered="handleIsRegistered" :language="$t('Language')"></snipp-registration>
      </div>
      <div id="thanks-text" v-if="upload_enabled === 'upload_again' || upload_enabled === 'thanks_only'">
        <br />
        <h2 v-html="$t('IPEwidget.ThanksTitle')" class="mb-4 title-color"></h2>
        <p v-html="$t('IPEwidget.ThanksDesc')"></p>
        <p v-html="$t('IPEwidget.TermsLink')" class="small mt-4"></p>
        <div class="mt-5">
          <a :href="$t('IPEwidget.ButtonLink')" target="_blank" class="btn btn-link">{{ $t('IPEwidget.Button') }}</a>
        </div>
      </div>
      <div id="rlr-text" v-if="upload_enabled === 'rlr_message'">
        <br />
        <h2 v-html="$t('IPEwidget.RLRTitle')" class="mb-4 title-color"></h2>
        <p v-html="$t('IPEwidget.RLRDesc')"></p>
        <p v-html="$t('IPEwidget.TermsLink')" class="small mt-4"></p>
        <div class="mt-5">
          <a :href="$t('IPEwidget.ButtonLink')" target="_blank" class="btn btn-link">{{ $t('IPEwidget.Button') }}</a>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import PageLoader from '../../../components/UI/PageLoader.vue';
export default {
  components: { PageLoader },
  props: ['campaignId'],
  emits: [],
  data() {
    return {
      ts: Date.now(),
      isLoading: true,
      is_loaded: false,
      is_logged_out: undefined,
      upload_enabled: undefined,
      registration_enabled: false,
      show_confirmation: undefined,
      user_status: undefined,
      customCssUrl: '/assets/css/custom_overrides.css',
      gateDob: sessionStorage.getItem('DateOfBirth') || undefined,
      saved_checkbox_terms: false,
      saved_checkbox_consent: false,
      saved_checkbox_marketing: false,
    };
  },
  methods: {
    findInShadowTree(root, id) {
      if (!root) return null;
      const direct = root.getElementById ? root.getElementById(id) : null;
      if (direct) return direct;

      const all = root.querySelectorAll ? root.querySelectorAll('*') : [];
      for (const el of all) {
        if (el.shadowRoot) {
          const found = this.findInShadowTree(el.shadowRoot, id);
          if (found) return found;
        }
      }
      return null;
    },
    async prefillIpeGateData() {
      const dobVal = sessionStorage.getItem('DateOfBirth') || this.gateDob;
      if (!dobVal) return;

      // HTML5 date inputs require exactly YYYY-MM-DD format.
      // Snipp DateOfBirth is often stored as ISO string with time (e.g. 1990-01-01T00:00:00) or MM/DD/YYYY
      let formattedDob = dobVal;
      try {
        if (/^\d{4}-\d{2}-\d{2}$/.test(dobVal)) {
          formattedDob = dobVal;
        } else if (/^\d{4}-\d{2}-\d{2}T/.test(dobVal)) {
          formattedDob = dobVal.substring(0, 10);
        } else {
          const d = new Date(dobVal);
          if (!isNaN(d.getTime())) {
            const yyyy = d.getFullYear();
            const mm = String(d.getMonth() + 1).padStart(2, '0');
            const dd = String(d.getDate()).padStart(2, '0');
            formattedDob = `${yyyy}-${mm}-${dd}`;
          } else {
            formattedDob = dobVal.substring(0, 10);
          }
        }
      } catch (e) {
        formattedDob = dobVal.substring(0, 10);
      }

      let dobDone = false;

      for (let i = 0; i < 40; i++) {
        const root = document.querySelector('snipp-registration')?.shadowRoot;
        if (root) {
          if (!dobDone) {
            const dob = this.findInShadowTree(root, 'input_birthdate');
            if (dob) {
              dob.value = formattedDob;
              dob.dispatchEvent(new Event('input', { bubbles: true }));
              dob.dispatchEvent(new Event('change', { bubbles: true }));
              dob.readOnly = true;
              dob.setAttribute('aria-readonly', 'true');
              dobDone = true;
            }
          }
          if (dobDone) return;
        }
        await new Promise((r) => setTimeout(r, 150));
      }
    },
    showRegistration(confirmation) {
      if (this.upload_enabled) this.upload_enabled = undefined;
      if (confirmation) {
        this.show_confirmation = true;
      } else {
        this.show_confirmation = undefined;
      }
      this.registration_enabled = true;
    },
    showConfirmation() {
      this.showRegistration(true);
    },
    handleSnippLogout() {
      this.upload_enabled = undefined;
      this.is_logged_out = true;
      this.showRegistration();
    },
    handleIsRegistered() {
      let isNewUser = false;
      const root = document.querySelector('snipp-registration')?.shadowRoot;

      if (root) {
        // We look inside the shadow DOM for the first name input.
        // A new user will have filled this out. An existing user bypassing the gate will not.
        const firstNameInput = this.findInShadowTree(root, 'input_firstname');
        if (firstNameInput && firstNameInput.value && firstNameInput.value.trim().length > 0) {
          isNewUser = true;
        }
        this.saved_checkbox_terms = this.findInShadowTree(root, 'checkbox_terms')?.checked || false;
        this.saved_checkbox_consent = this.findInShadowTree(root, 'checkbox_consent')?.checked || false;
        this.saved_checkbox_marketing = this.findInShadowTree(root, 'checkbox_marketing')?.checked || false;
      }

      console.log('handleIsRegistered determined isNewUser via shadowRoot:', isNewUser);

      if (isNewUser) {
        this.upload_enabled = 'thanks_only';
      } else {
        this.upload_enabled = 'rlr_message';
      }

      this.user_status = Date.now();
      this.registration_enabled = false;
    },
    handleCurrentUser(event) {
      this.registration_enabled = false;

      let user = null;
      if (event && event.detail) {
        if (Array.isArray(event.detail) && event.detail.length > 0) {
          user = event.detail[0];
        } else {
          user = event.detail;
        }
      }

      const isNewUser = this.upload_enabled === 'thanks_only';

      if (user) {
        window.dataLayer = window.dataLayer || [];
        const userInfo = user.user_info || {};

        if (isNewUser) {
          window.dataLayer.push({
            'event': 'sign_up',
            'method': 'Email',
            'login_status': 'success',
            'user': {
              'login_status': 'success',
              'user_id': user.Id || userInfo.Id || user.client_user_id || '',
              'email': user.email || userInfo.email || '',
              'first_name': userInfo.firstname || '',
              'last_name': userInfo.lastname || '',
              'birthdate': userInfo.dateofbirth ? userInfo.dateofbirth.substring(0, 10) : (userInfo.dob ? userInfo.dob.substring(0, 10) : (sessionStorage.getItem('DateOfBirth') ? sessionStorage.getItem('DateOfBirth').substring(0, 10) : '')),
              'zip': userInfo.zip || userInfo.zipcode || userInfo.postalcode || userInfo.postal_code || '',
              'state': userInfo.state || '',
              'country': userInfo.country || 'US',
              'city': userInfo.city || '',
              'address': userInfo.street || '',
              'address2': userInfo.streettwo || userInfo.address2 || '',
              'phone': userInfo.phone || userInfo.phonenumber || userInfo.mobile || '',
              'checkbox_terms': this.saved_checkbox_terms,
              'checkbox_consent': this.saved_checkbox_consent,
              'checkbox_marketing': this.saved_checkbox_marketing
            }
          });
        } else {
          window.dataLayer.push({
            'event': 'login',
            'method': 'Email',
            'login_status': 'success'
          });
        }
      }

      // If handleIsRegistered already set this to thanks_only, preserve it.
      // Otherwise, default to the RLR message for existing users.
      if (this.upload_enabled !== 'thanks_only') {
        this.upload_enabled = 'rlr_message';
      }
    },
  },
  mounted() {
    this.is_loaded = true;
    setTimeout(() => (this.isLoading = false), 1500);
  },
  watch: {
    registration_enabled(val) {
      if (val) {
        this.$nextTick(() => {
          this.prefillIpeGateData();
        });
      }
    }
  },
};
</script>

<style scoped>
.wrapper {
  margin-top: 57px;
}

.color-red {
  color: #bf233a;
}

#current-user-wrapper,
#upload-wrapper {
  max-width: 70%;
  margin: 0 auto
}

@media screen and (max-width: 575px) {

  #current-user-wrapper,
  #upload-wrapper {
    max-width: 100%;
    margin: 0 auto
  }
}
</style>
